import { render, staticRenderFns } from "./ImeiActiveReport.vue?vue&type=template&id=b06c1e7c&scoped=true&"
import script from "./ImeiActiveReport.vue?vue&type=script&lang=js&"
export * from "./ImeiActiveReport.vue?vue&type=script&lang=js&"
import style0 from "./ImeiActiveReport.vue?vue&type=style&index=0&id=b06c1e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c1e7c",
  null
  
)

export default component.exports